import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import baseUrl from '../../components/baseUrl';
import DashboardNav from '../../components/Nav/DashboardNav';
import Footer from '../../components/Footer/Footer';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import { LOCAL_STORAGE_TOKEN_KEY } from '../../utils/constants';
import bigStar from '../assets/bigStar.svg'

const Profile = () => {
    const [profile, setProfile] = useState([]); // User reviews
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");
    const [user, setUser] = useState(null);
    const [accessToken, setAccessToken] = useState(null);

    const navigate = useNavigate();

    function decodeData(data) {
        return atob(data); // Base64 decoding
    }

    useEffect(() => {
        const storeToken = window.localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
        if (!storeToken) {
            navigate('/');
            return;
        }

        const decodedToken = decodeData(storeToken);
        const userInfo = decodedToken ? jwtDecode(decodedToken) : null;

        if (userInfo) {
            setAccessToken(decodedToken);
            setUser(userInfo?.user);
        } else {
            navigate('/');
        }
    }, [navigate]);

    useEffect(() => {
        if (!user) return;

        const fetchProfileDetails = async () => {
            let config = {
                method: 'get',
                url: `${baseUrl}/profile/user/${user.user_id}`,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${JSON.parse(accessToken)}`
                }
            };

            try {
                const response = await axios.request(config);
                if (response.data.success) {
                    setProfile(response.data.data);
                } else if (response.data.success === false) {
                    setProfile([]); // Ensure it's an empty array
                }
            } catch (error) {
                setErrorMessage(error?.response?.data?.message || "Error fetching profile details.");
            } finally {
                setLoading(false);
            }
        };

        fetchProfileDetails();
    }, [user, accessToken]);


    console.log('profile', profile)

    return (
        <div>
            <DashboardNav />
            <div className='blog-container pt-[128px] md:pt-[122px]  lg:pt-[160px] px-[25px] md:px-[32px] mg:px-[64px] xl:px-[102px]'>

                {/* <h1 className='text-2xl font-bold text-center mb-6'>User Profile</h1> */}

                {/* Display User Info */}
                {user && (
                    <div className='flex gap-[14px] mb-[60px] md:mb-[70px] lg:mb-[54px] xk:mb-[73px] '>
                        <div className=' w-[80px]  h-[80px]  lg:w-[120px]  lg:h-[120px]  rounded-full flex items-center justify-center text-center bg-profile ' >
                            <h1 className='font-bold text-white text-[32px] leading-[40.5px] md:text-[40px] md:leading-[40.5px] '>{user?.first_name?.substring(0, 1)}{user?.last_name?.substring(0, 1)}</h1>
                        </div>
                        <div className=" flex gap-[2px] lg:gap-[7px] flex-col  ">
                            <p className='font-black text-[24px] leading-[32.4px] md:text-[30px] md:leading-[40.5px]'> {user.first_name} {user.last_name}</p>
                            <p className='font-medium text-ravash text-sm '>{user.email}</p>
                            <p className='mt-[16px] lg:mt-[9px] bg-ravblue text-white px-[16px] h-[29px] flex items-center justify-center rounded-[80px] w-[100px] text-base font-black gap-2'> {profile.length} <span className='font-medium'>Reviews</span> </p>
                        </div>
                    </div>
                )}

                {/* Loading Spinner */}
                {loading && (
                    <div className="flex justify-center items-center">
                        <AiOutlineLoading3Quarters className="animate-spin text-4xl text-gray-500" />
                    </div>
                )}

                {/* Error Message */}
                {errorMessage && (
                    <p className="text-red-500 text-center mt-4">{errorMessage}</p>
                )}

                {/* User Reviews Table */}
                <div className="bg-ravbg rounded-[20px] py-[25px] px-[28px] md:px-[31px] lg:px-[44px] xl:px-[46px] lg:py-[35px] xl:py-[41px]">

                    {profile.length > 0 ? (
                        <>
                            <p className='text-lg font-black lg:text-[24px] lg:leading-[32.4px] '>Ratings</p>

                            {profile.map((review, index) => (
                                <div className='flex flex-col'>
                                    <div key={review.feedback_id} className="mt-[15px] md:mt-0 flex gap-4 pb-[33px] lg:pb-[42px] md:items-center md:justify-between" >
                                        <div className='flex gap-4 xl:gap-5  md:mt-[26px] lg:mt-[34px]'>
                                            <img src={bigStar} alt="bigStar" className='w-[40px] h-[56px] lg:w-[56px] lg:h-[78px]' />

                                            <div className='flex flex-col gap-1'>
                                                <p className="text-sm lg:text-[24px] lg:leading-[32.4px] font-black mt-[7px]  md:mt-0">{review.vendor?.vendor_name || ""}</p>
                                                <div className="text-base lg:text-sm text-ravash flex gap-1 lg:gap-5">
                                                    {review.comments?.[0]?.event?.event_name || "No event name"}
                                                    <p>
                                                        {review.comments?.[0]?.event_date
                                                            ? new Date(review.comments[0].event_date).toLocaleDateString()
                                                            : "No date available"}
                                                    </p>
                                                </div>
                                                <p className="text-ravblue text-base  mt-[7px] font-medium px-[16px] w-fit h-[25px] border border-ravblue flex items-center justify-center rounded-[80px]">{review.vendor?.category?.category_name || ""}</p>



                                                <button
                                                    onClick={() => navigate(`/edit/`, { state: { review } })}
                                                    className=" md:hidden bg-ravblue font-bold text-white text-sm rounded-[80px] h-[45px] w-[107px] mt-[28px] "
                                                >
                                                    Edit
                                                </button>

                                            </div>
                                        </div>
                                        <button
                                            onClick={() => navigate(`/edit/`, { state: { review } })}
                                            className=" hidden md:block bg-ravblue font-bold text-white text-sm rounded-[80px] h-[45px] lg:h-[50px] w-[107px]  lg:w-[160px] "
                                        >
                                            Edit
                                        </button>

                                    </div>

                                    <div className={`border-t w-full border-ravgray mb-[8px] ${index === profile.length - 1 ? 'border-none' : ''}`} />


                                </div>
                            ))}



                        </>
                    ) : (
                        <div className='flex flex-col gap-1  items-center h-screen mt-[54px] md:h-[44vh]  md:h-[50vh] xl:h-[40vh]'>
                            <p className="font-black text-[24px] leading-[32.4px] md:text-[30px] md:leading-[40.5px]">Rate your first Vendor</p>
                            <p className="text-base lg:text-sm text-ravash flex gap-1 lg:gap-5 text-center">Share your experience! Your feedback
                                will help others make informed
                                decisions and help vendors
                                improve
                            </p>

                            <button
                                onClick={() => navigate('/rate')}
                                className="  bg-ravblue font-bold text-white text-sm rounded-[80px] h-[45px] w-[187px] md:w-[193px] lg:w-[200px] mt-[28px] "
                            >
                                Rate A Vendor
                            </button>

                        </div>

                    )
                    }
                </div>

            </div >
            <Footer />
        </div >
    );
};

export default Profile;
